<template>
  <material-card>
    <v-toolbar slot="header" color="primary">
      <v-toolbar-title>Leads</v-toolbar-title>
      <v-spacer></v-spacer>
      <search-bar :searchColumns="filteredSearchColumn" @search-query="getLeads"></search-bar>
    </v-toolbar>

    <v-data-table
      :headers="leadsTable.headers"
      :items="leadsTable.data"
      :options.sync="leadsTableOptions"
      :loading="leadsTable.loading"
      dense
      class="elevation-1"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 20, 30, 50],
      }"
      :items-per-page="itemsPerPage"
    >
      <template slot="headerCell" slot-scope="{ header }">
        <span
          class="font-weight-light text-warning text--darken-3"
          v-text="header.text"
        />
      </template>
      <template v-slot:item.email="{ item }">
        <td>
          {{ item.email
          }}<v-icon class="pl-1" x-small :color="item.email_confirmed ? 'green' : ''" v-if="item.email">
            mdi-checkbox-marked-circle
          </v-icon>
        </td>
      </template>
      <template v-slot:item.votes_date="{ item }">
        <td>{{ item.votes_date | formatDateSmall }}</td>
      </template>
      <template v-slot:item.voted="{ item }">
        <td>
          <v-icon :color="item.votes_date !== null ? 'green' : ''">
            mdi-checkbox-marked-circle
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </material-card>
</template>
<script>
import apiService from '@/services'
import searchBar from '@/components/common-components/ComponentSearchBar'

export default {
  props: {
    campaign: {
      type: String || Number,
      required: false
    },
    itemsPerPage: {
      type: Number,
      required: false,
      default: 10
    }
  },
  watch: {
    leadsTableOptions: {
      handler () {
        this.getLeads()
      },
      deep: true
    }
  },
  components: {
    searchBar
  },
  computed: {
    filteredSearchColumn () {
      // Table headers are also used for search porpuses
      // Filter out unsearchable headers
      return this.leadsTable.headers.filter((item) => item.searchable !== false)
    }
  },
  data () {
    return {
      leadsTable: {
        headers: [
          {
            text: 'First name',
            value: 'first_name',
            sortable: true
          },
          { text: 'Last name', value: 'last_name', sortable: true },
          { text: 'Email', value: 'email', sortable: true },
          { text: 'Client', value: 'client_name', sortable: true },
          { text: 'Merchant', value: 'merchant_name', sortable: true },
          { text: 'Vote date', value: 'votes_date', sortable: true },
          { text: 'Npo', value: 'npo_name', sortable: true },
          { text: 'Has voted', value: 'voted', sortable: true }
        ],
        data: [],
        total: 0,
        loading: false,
        options: {}
      },
      leadsTableOptions: {}
    }
  },
  methods: {
    /* #############################
    #           Leads              #
    ############################## */
    getLeads (searchParams = {}) {
      this.leadsTable.loading = true

      const { sortBy, sortDesc, page, itemsPerPage } = this.leadsTableOptions

      let filter = {}
      filter.orderBy = sortBy[0] || null
      filter.orderDesc = sortDesc[0] || null
      filter.page = page
      filter.limit = itemsPerPage

      filter.campaign = this.campaign

      filter.search_filter =
        !!searchParams && searchParams.tableSearch !== ''
          ? searchParams.searchColumn
          : ''
      filter.search_value = searchParams.tableSearch || ''

      apiService
        .fetchData('leads', filter)
        .then((response) => {
          if (response === null) {
            response = []
          }
          this.leadsTable.data = response
          // this.leadsTable.total = response.total
          this.leadsTable.loading = false
        })
        .catch((error) => {
          this.leadsTable.loading = false
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Cannot update client ${error}`
          })
        })
    }
  }
}
</script>
